
import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../redux/modules/actions';
import StripedProgressBar     from './StripedProgressBar';

const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterStripedProgressBar: actions.enterStripedProgressBar,
        leaveStripedProgressBar: actions.leaveStripedProgressBar
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StripedProgressBar);



// WEBPACK FOOTER //
// ./src/app/views/stripedProgressBar/index.js